import React, { useState, useEffect } from "react";
import ReactECharts from "echarts-for-react";
import NavTabs from "../../../shared/NavTabs";
import { getCSSPropertyValue } from "../../../../utils/styles";

enum ChartCategory {
    DEPARTMENT = 'department',
    STATE = 'state',
    LOCATION = 'location',
    VERTICAL = 'vertical',
    ASSOCIATE_COMPANY = 'associate_company'
}


const colors = ['--emarald-green', '--orange', '--medium-red'];

const list = [
    { value: ChartCategory.ASSOCIATE_COMPANY, label: 'Associate Company' },
    { value: ChartCategory.STATE, label: 'State' },
    { value: ChartCategory.LOCATION, label: 'Location' },
    { value: ChartCategory.VERTICAL, label: 'Vertical' },
    { value: ChartCategory.DEPARTMENT, label: 'Department' }
]

const Status: any = {
    'On Time': 'OnTime',
    'Late Closure': 'Late',
    'Non-Compliant': 'NonCompliance'
}

export default function DashboardCharts({ data }: any) {
    const [category, setCategory] = useState(ChartCategory.ASSOCIATE_COMPANY);
    const [options, setOptions] = useState<any>(null);

    const [defaultOption] = useState<any>({
        color: colors.map(color => getCSSPropertyValue(color)),
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross'
            }
        },
        legend: {
            data: ['On Time', 'Late Closure', 'Non-Compliant']
        },
        xAxis: [
            {
                type: 'category',
                axisTick: {
                    alignWithLabel: true
                }
            }
        ],
        yAxis: [
            {
                type: 'value',
                name: 'On Time',
                position: 'left',
                alignTicks: true,
                nameRotate: 90,
                nameLocation: 'center',
                nameGap: 50,
                axisLine: {
                    show: true
                },
                axisLabel: {
                    formatter: '{value}'
                }
            },
            {
                type: 'value',
                name: 'Late Closure, Non-Compliant',
                position: 'right',
                alignTicks: true,
                nameRotate: 270,
                nameLocation: 'center',
                nameGap: 20,
                axisLine: {
                    show: true
                },
                axisTick: {
                    show: true
                },
                axisLabel: {
                    formatter: '{value}'
                }
            }
        ],
        dataset: {
            source: [
            ]
        },
        series: [
            {
                seriesLayoutBy: 'row',
                type: 'bar',
                barWidth: 16,
                label: {
                    show: true,
                    position: 'top'
                }
            },
            {
                type: 'bar',
                smooth: true,
                seriesLayoutBy: 'row',
                barWidth: 16,
                label: {
                    show: true,
                    position: 'top'
                }
            },
            {
                type: 'bar',
                smooth: true,
                seriesLayoutBy: 'row',
                barWidth: 16,
                label: {
                    show: true,
                    position: 'top'
                }
            }
        ]
    });

    useEffect(() => {
        if(data && category) {
            const source = [[category], ['On Time'], ['Late Closure'], ['Non-Compliant']];
            const groups = ['', 'On Time', 'Late Closure', 'Non-Compliant'];
            const _options = JSON.parse(JSON.stringify(defaultOption));
            const response = data[category];
            if(response) {
                response.forEach((group: any) => {
                    source[0].push(group.name);
                    groups.forEach((x: string, i: number) => {
                        if (Boolean(x)) {
                            const index = group.values.findIndex((a: any) => a.name === Status[x]);
                            if (index === -1) {
                                source[i].push(0 as any);
                            } else {
                                source[i].push(group.values[index].value)
                            }
                        }
                    })
                });
                _options.dataset.source = source;
                setOptions(_options);
            }
        }
    }, [category, data])

    return (
        <>
            <div className="mb-2 text-appprimary text-xl fw-bold">Compliance Status by Category</div>
            <NavTabs list={list} onTabChange={setCategory} />
            <div className="w-100 mt-2">
                {
                    options && <ReactECharts option={options} />
                }
            </div>
        </>
    )
}